import { FormControl, FormGroup } from '@angular/forms';
import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.component';
import { PickupManifest } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`Pickup Manifest`,
  DATE: $localize`Date`,
  FROM: $localize`From`,
  ROUTE: $localize`Route`,
};

export const REPORT_FILE_NAME = 'Pickup-Manifest-Report';

export const PDF_REPORT = {
  NAME: 'Pickup Manifest',
  HEADER: {
    LOCATION: 'Location:',
    LOOP: 'Loop:',
    USER: 'User Id:',
  },
  FOOTER: {
    SUMMARY: 'Summary',
    LOCATION: 'Location: ',
    LOOP: 'Loop: ',
    USER: 'User Id: ',
    PICKUP_STOPS: 'Pickup Stops: ',
    PICKUP_PACKAGES: 'Pickup Packages: ',
    TOTAL_COLLECTED: 'Total Collected: ',
  },
  COLUMNS: [
    [
      'Stop'.toUpperCase(),
      'Customer'.toUpperCase(),
      'Street'.toUpperCase(),
      '',
      'City'.toUpperCase(),
      'Province'.toUpperCase(),
      'Postal Code'.toUpperCase(),
    ],
    [
      'Trackno'.toUpperCase(),
      'Shipper'.toUpperCase(),
      'Val'.toUpperCase(),
      'Coll'.toUpperCase(),
      'ScanCode'.toUpperCase(),
      'Time'.toUpperCase(),
      'PRN'.toUpperCase(),
    ],
  ],
  DATA_FIELDS: [
    'loop',
    'customer',
    'street',
    'city',
    'prov',
    'postalcode',
    'trackno',
    'shipper',
    'val',
    'coll',
    'scancode',
    'time',
    'prn',
  ] as (keyof PickupManifest)[],
  DATA_ROWS: [
    [
      'stop',
      'customer',
      'street',
      '',
      'city',
      'prov',
      'postalcode',
    ] as (keyof PickupManifest)[],
    [
      'trackno',
      'shipper',
      'val',
      'coll',
      'scancode',
      'time',
      'prn',
    ] as (keyof PickupManifest)[],
  ],
};

export type PickupManifestGroup = {
  stop: string;
  routeId?: string;
  pickupManifests: PickupManifest[];
  time: string;
};

export type PickupManifestFormField = {
  fromDate: FormControl<Date>;
  toDate: FormControl<Date>;
  route: FormControl<string>;
  reportFormat: FormControl<Options>;
};

export type PickupManifestFormGroup = {
  form: FormGroup<PickupManifestFormField>;
  routes: IOption[];
} | null;
